import React, { Ref, TextareaHTMLAttributes, forwardRef } from 'react';

/**
 * 기본 타이포그래피/스크롤바는 globals.css 의 .form-textarea-base 에 있다.
 * 유틸리티로 두면 TextareaBox 같은 caller 가 덮어쓸 수 없다
 * (모든 유틸리티가 !important 라 승자가 CSS 출력 순서로 정해진다).
 */
const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(
  (
    { disabled, readOnly, className, ...props },
    ref: Ref<HTMLTextAreaElement>,
  ) => {
    return (
      <textarea
        disabled={disabled}
        readOnly={readOnly}
        ref={ref}
        className={`form-textarea-base ${
          readOnly ? 'pointer-events-none bg-transparent' : ''
        } ${
          disabled ? 'bg-transparent text-apps-coreProductDisableContent' : ''
        } ${className ?? ''}`}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';

export default Textarea;
